module.exports = __webpack_public_path__ + "static/media/band-frontal.1f458796.jpg";